module.exports = __webpack_public_path__ + "img/icon_menu_round_vertical.33225328.svg";